<template>
  <div>
    <textarea ref="redactor" :name="name" :placeholder="placeholder" :value="value" />
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    value: {
      default: '',
      type: String,
    },
    placeholder: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      config: {
        default: {},
        type: Object,
      },
      htmlView: false,
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (!this.redactor.editor.isFocus()) {
        this.redactor.source.setCode(newValue);
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const _this = this;
      const callbacks = {
        changed(html) {
          _this.handleInput(html);
          return html;
        },
        source: {
          close(html) {
            _this.htmlView = false;
            _this.$emit('enableSave', true);
          },
          open() {
            _this.htmlView = true;
            _this.$emit('enableSave', false);
          },
        },
      };

      if (!Object.keys(this.config).length) {
        this.config = {
          plugins: ['table', 'alignment', 'fontcolor', 'fontfamily', 'fontsize', 'video'],
          // Strike through element does not get saved in vue/mongo for some reason
          // Disabled unless we really need it - then debug why not working.
          buttonsHide: ['deleted'],
        };
      }

      // extend config
      Vue.set(this.config, 'callbacks', callbacks);

      // call Redactor
      const app = window.$R(this.$refs.redactor, this.config);

      // set instance
      this.redactor = app;
      this.$parent.redactor = app;
    },
    handleInput(val) {
      // Only allow change event if the HTML editor is not open, otherwise the HTML will be automatically
      // overwritten and cleaned up, as the user is typing.
      if (!this.htmlView) {
        // @TODO - Can't understand why this is required to set back data to the parent,
        // @TODO - the parent component does nothing with this event.
        this.$emit('input', val);
        // Tell parent some data was changed
        this.$emit('changeMade', true);
      }
    },
  },
};
</script>
